<template>
	<div class="col-lg-12 actions">
		<button
			v-if="customer.supportConsent || (customer.organization && !customer.organization.freemium)"
			class="btn btn-login"
			:disabled="loading"
			@click="signIn">
			<template v-if="loading">
				<i class="fa fa-spinner fa-spin fa-fw" />
			</template>
			<template v-else>
				{{ $t('enterAs') }} <strong>{{ customer.domain }}</strong>
			</template>
		</button>

		<template v-else>
            <span
				v-if="!customer.onboarded"
				class="attention">
				{{$t('customers.didNotOnboard') }}
			</span>
			<span
				class="attention"
				v-if="!customer.supportConsent && customer.organization && !customer.organization.freemium">
                {{ $t('customers.noSupportConsent') }}
            </span>
			<span
				v-if="!users.length"
				class="attention">
				{{ $t('customers.noUser') }}
			</span>
		</template>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'GhostIdentityButton',
	props: {
		customer: {
			type: Object
		}
	},
	data () {
		return {
			loading: false
		}
	},
	computed: {
		...mapGetters('identity', {
			identity: 'getIdentity'
		}),
		...mapGetters('customer', {
			customers: 'getCustomers',
		}),
		users () {
			return this.customer.users.filter(user => user.deleted === null);
		}
	},
	methods: {
		...mapActions('ghost', ['logInAsGhost']),

		async signIn () {
			try {
				this.loading = true

				const payload = {};

				if (!this.users || !this.users.length) {
					payload.customerId = this.customer.id;
				} else {
					payload.email = this.users[0].email;
				}
				await this.logInAsGhost(payload);

				this.loading = false

				if (this.customers.length > 1) {
					this.$router.push({ name: 'account.selection' })
				} else {
					this.$router.push({ name: 'frontend.overview' })
				}

			} catch (e) {
				throw e;
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/vars";
@import "~@/assets/scss/variables/all";

.btn-login {
	width: 100%;
	background: $digital-blue;
	color: $white;
	border: none;
	opacity: 1;
	transition: all 0.2s ease;
	cursor: pointer;
	border-radius: 2px;
	padding: 10px;

	&:hover {
		background: darken($digital-blue, 5%);
	}
}

button:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}
</style>
